export default "__VITE_ASSET__oEuPRnSe__"